<iris-card class="account-info-card" [formGroup]="form" *ngIf="user() && user().loaded">
  <div class="contact-support">
    All fields required unless marked optional. To update your legal name, email, address, or primary virtual address, contact
    <a href="mailto:{{legalEmailLink}}" data-test="support-email">
      {{ supportEmail() }}
    </a>
  </div>
  <div class="iris-card-basic" data-test="title-account">Basic</div>
  <div>
    <div class="basic-info-row-container">
      <iris-form-field
        label="Name"
        [showOptionalTag]="false"
      > 
        <iris-text-input
          type="text"
          formControlName="displayName"
          data-test="account-info-card-name" 
          data-dd-action-name="provider name"
        >
        </iris-text-input>
      </iris-form-field>

      <iris-form-field
        label="Email"
        [showOptionalTag]="false"
      > 
        <iris-text-input
          type="text"
          formControlName="email"
          data-test="email"
        >
        </iris-text-input>
      </iris-form-field>
    </div>
    
    <div class="basic-info-row-container">
      <iris-form-field
        label="Practice name (optional)"
        [showOptionalTag]="false"
      > 
        <iris-text-input
          type="text"
          formControlName="practiceName"
          placeholder="Practice name (optional)"
          data-test="practice-name"
        >
        </iris-text-input>
      </iris-form-field>

      <iris-form-field
        label="Timezone"
        [showOptionalTag]="false"
      > 
        <iris-text-input
          type="text"
          formControlName="timeZone"
          data-test="default-time-zone"
        >
        </iris-text-input>
      </iris-form-field>
    </div>

    <div class="basic-info-row-container">
      <iris-form-field
        class="large-field"
        label="Phone number (private)"
        [showOptionalTag]="false"
      >
        <iris-text-input
          type="tel"
          placeholder="Phone number (private)"
          formControlName="phoneNumber"
          [mask]="_maskingService.ngxMaskPhoneNumber"
          data-test="phone-number"
          required
        >
        </iris-text-input>
      </iris-form-field>

      <iris-form-field
        class="large-field"
        label="Private cell number (optional)"
        [showOptionalTag]="false"
      >
        <iris-text-input
          type="text"
          formControlName="cellphoneNumber"
          placeholder="Private cell number (optional)"
          [mask]="_maskingService.ngxMaskPhoneNumber"
          data-test="sms-phone-number"
        >
        </iris-text-input>
      </iris-form-field>


      <iris-checkbox
        formControlName="subscriptionSms"
        data-test="sms-checkbox"
        class="sms-checkbox-container"
      >Subscribe to SMS updates
      </iris-checkbox>
    </div>
  </div>

  <ng-container *ngIf="showVirtualAddress()">
    <section class="virtual-address">
      <div class="iris-card-title" data-test="primary-virtual-address-title">
        <h3 class="title iris-h3-responsive">Primary virtual address</h3>
      </div>
      <div class="helper-text iris-body-responsive">Used to determine pay when using SonderMind Virtual Locations.</div>
      <div>
        <ng-container *ngIf="primaryVirtualAddressNotEmpty(); else noPrimaryVirtualAddress">
          <div class="iris-body-responsive" data-dd-action-name="provider address">
            <div *ngIf="primaryVirtualAddress().addressLine1">{{primaryVirtualAddress().addressLine1}},</div>
            <div *ngIf="primaryVirtualAddress().addressLine2">{{primaryVirtualAddress().addressLine2}},</div>
            <div>
              <span *ngIf="primaryVirtualAddress().city">{{primaryVirtualAddress().city}}, </span>{{primaryVirtualAddress().state}} {{primaryVirtualAddress().postalCode}}
            </div>
          </div>
        </ng-container>
      </div>
    </section>

    <ng-template #noPrimaryVirtualAddress>
      <section class="no-pva-text iris-body-responsive">
        No primary virtual address added
      </section>
    </ng-template>
  </ng-container>


  <div class="legal-address">
    <div class="iris-card-title" data-test="billing-address-title">
      Legal address
    </div>
    @if (!isSaasEnabled()) {
      <div class="iris-card-subtitle">Filed on your W-9</div>
    }

    <div class="address" *ngIf="user().billingAddress as address;" data-dd-action-name="provider address">
      <ng-container *ngIf="addressNotEmpty(address); else noBillingAddress">
        <p>{{address.addressLine1}}</p>
        <p *ngIf="address.addressLine2">{{address.addressLine2}}</p>
        <p>
          <span *ngIf="address.city">{{address.city}}, </span>{{address.state}} {{address.postalCode}}
        </p>
      </ng-container>
    </div>

    <ng-template #noBillingAddress>
      <p class="address-missing">
        {{ addressMissingMessage() }}
      </p>
    </ng-template>
  </div>

  @if (!isSaasEnabled()) {
    <ng-container *ngIf="mailingAddressIsVisible">
      <iris-checkbox
        data-test="mailing-address-is-different"
        formControlName="mailingAddressIsDifferent"
        (change)="toggleMailingAddress()"
        class="mailing-address-is-different-checkbox"
      > 
        Mailing address is different than legal address
      </iris-checkbox>
      <ng-container *ngIf="form.get('mailingAddressIsDifferent').value">
        <iris-card class="address-container">
          <div class="iris-card-title" data-test="mailing-address-title">Mailing address</div>
          <div>
            <div class="iris-body-responsive">
              For SonderMind mail
            </div>

            <form [formGroup]="$any(form.get('mailingAddress'))" (keydown.enter)="onSubmit()">
              <div class="street-line">
                <iris-form-field
                  class="address1"
                  label="Street Address"
                  [showOptionalTag]="false"
                >
                  <iris-text-input
                    formControlName="addressLine1"
                    googleMapsAutoComplete
                    [autocompleteParams]="{ componentRestrictions: { country: 'us' }, types: ['address'] }"
                    (onAutoCompleteSelected)="locationSelected($event)"
                    data-test="mailing-address-1"
                  >
                  </iris-text-input>
                </iris-form-field>
                <iris-form-field
                  class="address2"
                  label="Apartment, unit, suite, or floor #"
                >
                  <iris-text-input formControlName="addressLine2" data-test="mailing-address-2">
                  </iris-text-input>
                </iris-form-field>
              </div>
              <div class="city-state-zip-line">

                <iris-form-field
                  class="city"
                  label="City"
                  [showOptionalTag]="false"
                >
                  <iris-text-input formControlName="city" data-test="city">
                  </iris-text-input>
                </iris-form-field>
                <iris-form-field
                  class="state"
                  label="State"
                  [customErrorMessages]="addressErrors"
                  [showOptionalTag]="false"
                >
                  <iris-text-input formControlName="state" data-test="state">
                  </iris-text-input>
                </iris-form-field>
                <iris-form-field
                  class="zip"
                  label="Zip Code"
                  [customErrorMessages]="addressErrors"
                  [showOptionalTag]="false"
                >
                  <iris-text-input formControlName="postalCode" data-test="zip">
                  </iris-text-input>
                </iris-form-field>
              </div>
            </form>
          </div>
        </iris-card>
      </ng-container>
    </ng-container>
  }
  
  <iris-button-container class="button-container" [alignment]="irisButtonContainerAlignments.END">
    <iris-button
      class="save-button"
      data-test="save-account"
      [disabled]="saving()"
      (click)="onSubmit()"
    >
      Save
    </iris-button>
  </iris-button-container>
</iris-card>

@if (!isSaasEnabled()) {
  <sondermind-primary-virtual-address-card
    [primaryVirtualAddress]="primaryVirtualAddress()"
  >
  </sondermind-primary-virtual-address-card>
}

<sondermind-alert-modal #alertMessage></sondermind-alert-modal>
